import React from "react";

export default function infoSvg() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        display="inline"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 10C2.5 5.58172 6.08172 2 10.5 2C12.6217 2 14.6566 2.84285 16.1569 4.34315C17.6571 5.84344 18.5 7.87827 18.5 10C18.5 14.4183 14.9183 18 10.5 18C6.08172 18 2.5 14.4183 2.5 10ZM3.89999 10C3.89999 13.6451 6.85491 16.6 10.5 16.6C14.1428 16.5945 17.0945 13.6428 17.1 10C17.1 6.35492 14.1451 3.4 10.5 3.4C6.85491 3.4 3.89999 6.35492 3.89999 10ZM10.5 8C11.0523 8 11.5 7.55229 11.5 7C11.5 6.44772 11.0523 6 10.5 6C9.94771 6 9.49999 6.44772 9.49999 7C9.49999 7.55229 9.94771 8 10.5 8ZM12.19 13.385C12.19 13.3833 12.19 13.3817 12.19 13.38V13.3899C12.19 13.3882 12.19 13.3866 12.19 13.385ZM11.49 14.08C11.8749 14.08 12.1873 13.7693 12.19 13.385C12.1873 13.0045 11.881 12.6954 11.5 12.69H11.2V9.64C11.2 9.2534 10.8866 8.94 10.5 8.94H9.5C9.1134 8.94 8.79999 9.2534 8.79999 9.64C8.79999 10.0266 9.1134 10.34 9.5 10.34H9.8V12.68H9.5C9.1134 12.68 8.79999 12.9934 8.79999 13.38C8.79999 13.7666 9.1134 14.08 9.5 14.08H11.49Z"
        fill="#2C5CC5"
      />
    </svg>
  );
}
